<!--
 * @Author: your name
 * @Date: 2021-12-04 15:30:57
 * @LastEditTime: 2021-12-30 13:46:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \new-website-1123\src\views\special\sf101\page2.vue
-->
<template>
  <div class="sf101-page2">
    <div class="img-div">
      <img
        src="https://stkjiot.com/resources/special/sf101/1.png"
        alt="上太科技"
      />
    </div>

    <div class="text-div">
      <span>智能操控</span>
      <span>节水节肥</span>
    </div>
    <div class="filter-div"></div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.sf101-page2 {
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  z-index: 2;
  overflow: hidden;
  .img-div {
    display: none;
  }
  .text-div {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2;
    font-size: 100px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1dbf73;
    line-height: 120px;
  }
  .filter-div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
    background-color: rgba($color: #161616, $alpha: 0.8);
    background-image: radial-gradient(
      rgba($color: #161616, $alpha: 0.7),
      rgba($color: #161616, $alpha: 1)
    );
  }
  .img-di {
    display: none;
    opacity: 0;
  }
}

@media screen and (max-width: $mobile-width) {
  .sf101-page2 {
    position: relative;
    height: auto;
    width: 100%;
    top: 0;
    z-index: 2;
    overflow: hidden;
    padding: 20px 0;
    .img-div {
      display: flex;
      justify-content: center;
      opacity: 1;
      img {
        width: 86%;
      }
    }
    .text-div {
      opacity: 1;
      position: absolute;
      font-size: 0.55rem;
      line-height: 1.09rem;
    }
    .filter-div {
      opacity: 1;
      background-color: rgba($color: #161616, $alpha: 0.8);
      background-image: radial-gradient(
        rgba($color: #161616, $alpha: 0.7),
        rgba($color: #161616, $alpha: 1)
      );
    }
  }
}
</style>
